document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCifras();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initCifras() {
  var els = document.querySelectorAll('[data-mt-cifra]');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-mt-cifra')) || 0;
        var suffix = el.getAttribute('data-mt-sufijo') || '';
        if (reduced) {
          el.textContent = target + suffix;
          return;
        }
        var start = null;
        var duracion = 1400;
        function paso(ts) {
          if (!start) start = ts;
          var progreso = Math.min((ts - start) / duracion, 1);
          var valor = Math.floor(progreso * target);
          el.textContent = valor + suffix;
          if (progreso < 1) requestAnimationFrame(paso);
          else el.textContent = target + suffix;
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}
